import React from 'react';
import { observer } from 'mobx-react';
import { Divider, Tooltip } from 'antd';
import { useStore } from '../../../../store/rootStore';
import styles from './ChatItemTags.module.scss';
const ChatTagsTitle = ({ departmentId, chatLabels }) => {
    const { departmentsStore, labels } = useStore();
    const getDepartment = () => {
        if (!departmentId)
            return null;
        const department = departmentsStore.departments.find((d) => d._id === departmentId);
        if (department) {
            return department;
        }
        return null;
    };
    const getLabels = () => {
        if (!chatLabels)
            return [];
        return chatLabels.map((labelId) => labels.getLabelData(labelId)).filter((label) => !!label);
    };
    const allLabels = getLabels();
    const maxLabels = 5;
    const displayedLabels = allLabels.slice(0, maxLabels);
    const useEqualWidth = displayedLabels.length >= 3;
    const department = getDepartment();
    const renderTooltipContent = () => (React.createElement("div", { className: styles.labelTooltip }, allLabels.map((label) => (React.createElement("span", { key: label.id, className: styles.label, style: { backgroundColor: label === null || label === void 0 ? void 0 : label.color } }, label.name)))));
    return (React.createElement("div", { className: styles.container },
        department && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: styles.department, style: { backgroundColor: department.color } }, department.name),
            React.createElement(Divider, { type: "vertical", className: styles.divider }))),
        displayedLabels.length > 0 && (React.createElement(Tooltip, { title: renderTooltipContent(), placement: "top", overlayClassName: styles.labelTooltip, color: "white" },
            React.createElement("div", { className: `${styles.labelsContainer} ${useEqualWidth ? styles.equalWidth : ''}` }, displayedLabels.map((label) => (React.createElement("span", { key: label.id, className: styles.label, style: { backgroundColor: label === null || label === void 0 ? void 0 : label.color } }, label.name))))))));
};
export default observer(ChatTagsTitle);
